import { render, staticRenderFns } from "./RoomModalItem.vue?vue&type=template&id=4704b76c&"
import script from "./RoomModalItem.vue?vue&type=script&lang=js&"
export * from "./RoomModalItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports